import React from 'react';
import { Section } from '../components/Section';
import { StartHere } from '../components/StartHere';
import { asset } from '../data/redesignAssets';
import { TEAM } from '../data/team';
export function About() {
  return <>
      <Section n="01" label="About" noTop contentClassName="page-hero" data-id="element-341" data-mp="29l6pp8bd7jge">
        <h1 className="h1" style={{
        maxWidth: 1000
      }} data-id="element-342" data-mp="2ehx65wr30h2c">
          The Missing Half of the AI Stack
        </h1>
        <p className="lede" style={{
        maxWidth: 960
      }} data-id="element-343" data-mp="329cbzzi2hgic">
          Your AI stack is brilliant at storing what your company knows, easily recalling every document, file, and database you give
          it—but knowledge alone is only half the equation. The missing half is the strict brand guidelines, legal guardrails, and
          operational obligations that dictate how your business actually functions at its best. Whether a human is typing a quick prompt
          or a developer is coding an autonomous agent, those critical constraints cannot be left to chance, human memory, or downstream
          retrieval. <strong data-id="element-344" data-mp="1uil4pk9igiki">We built Synthia to be the definitive instruction layer for the enterprise</strong>, a seamless pre-flight checkpoint that
          automatically injects your highest-stakes obligations before a single token is generated. By ensuring every input reaches the
          model entirely complete, Synthia delivers the right answer the first time—guaranteed by an immutable, auditable receipt that
          proves your AI behaved exactly as intended.
        </p>
      </Section>

      <section className="bleed sec-dk does" data-id="element-345" data-mp="28gi4sqn6b73x">
        <div className="sec" style={{
        borderTop: 0
      }} data-id="element-346" data-mp="28fqftyo307mm">
          <div className="sec-m" data-id="element-347" data-mp="2m7o8kyxhjqwm">
            <div className="sec-l" data-id="element-348" data-mp="2mb2egh5cyi8t">Why</div>
          </div>
          <div className="why-c" data-id="element-349" data-mp="2i8fhy2xqs95a">
            <p className="why" data-id="element-350" data-mp="2i9h1kvstq3ym">
              The fifth time we saw the same correction, we stopped calling it a correction. It was a missing obligation, and the model
              kept committing us without it.
              <br data-id="element-351" data-mp="2r67y19bafktq" />
              <span style={{
              color: 'var(--mint)'
            }} data-id="element-352" data-mp="1ov6adj7iip3u">So we automated the obligations.</span>
            </p>
          </div>
        </div>
      </section>

      <Section n="03" label="The people" data-id="element-353" data-mp="1swhrt1g8g40y">
        <h2 className="h2" data-id="element-354" data-mp="1xvkwulw7qa8x">Humans in the loop.</h2>
        <div className="team" data-id="element-355" data-mp="1xtrlwuekh3v4">
          {TEAM.map(p => <div className="person" key={p.name} data-id="element-356" data-mp="22mb1fwwte92k">
              <img src={asset(p.photo)} alt={p.name} loading="lazy" data-id="element-357" data-mp="22o4cdoegnfgd" />
              <div className="id" data-id="element-358" data-mp="27kclol5z8efm">
                <div className="nm" data-id="element-359" data-mp="27ngvpz64i4e7">{p.name}</div>
                <div className="rl" data-id="element-360" data-mp="2cj5zyft389gu">{p.role}</div>
              </div>
              <div className="bio" data-id="element-361" data-mp="2gm2bjmk7n5ba">{p.bio}</div>
            </div>)}
        </div>
      </Section>

      <StartHere n="04" data-id="element-362" data-mp="2llf9b2cmdwsn" />
    </>;
}